export const invoicesTableColumns = [
  { prop: 'created', name: 'Date', sortable: true, flexGrow: 1, minWidth: 100 },
  {
    prop: 'invoice_number',
    name: 'Invoice Number',
    sortable: true,
    flexGrow: 1,
    minWidth: 150,
  },
  {
    prop: 'amount',
    name: 'Amount',
    sortable: true,
    flexGrow: 1,
    cellClass: 'text-end',
    headerClass: 'text-end',
    minWidth: 100,
  },
  {
    prop: 'actions',
    name: 'Download Invoice',
    sortable: false,
    width: 160,
    minWidth: 160,
    resizeable: false,
    canAutoResize: false,
  },
];
